import styled from "styled-components";
import FlexBox, { FlexGrow } from "./FlexBox";
import { ClickableIcon } from "./Icon";
import Modal from "./Modal";
import TableComponent, { StyledTableCell, StyledTableRow } from "./Table";
import { Checkbox, TableBody, TableHead, TableRow } from "@mui/material";
import { useContext, useEffect, useRef, useState } from "react";
import axios from "axios";
import LoadingSpinner from "./LoadingSpinner";
import { UserContext } from "../context/UserContext";
import SemesterSelect from "./SemesterSelect";
import StudentYearSelector from "./StudentYearSelector";
import { SemesterContext } from "../context/SemesterContext";
import { Icon } from "@mui/material";
import Input, { InputContainer, InputIconContainer } from "./Input";
import Student from "../types/Student";
import Button, { CancelButton } from "./Button";
import MUIButton from "@mui/material/Button";
import { handleJWTError } from "../hooks/jwtErrHandler";
import { StyleElements } from "../pages/RoadMap/StudentTimelines";
import MinimalSelect from "./MinimalSelect";
import { UniversityContext } from "../context/UniversityContext";

type SelectStudentModalProps = {
  isOpen?: boolean;
  setOpen: (x: boolean) => void;
  setStudent: (x: any) => void;
};
const CustomBox = styled(FlexBox)`
  padding: 12px 12px;
  background: #090a14;
  border-bottom: 1px solid #262a7d4a;
  // gap: 100px;
`;

interface Column {
  id: "cmkl_id" | "name" | "nickname" | "advisor" | "email" | "status" | "cie_dual_degree";
  label: string;
  minWidth?: number;
  align?: "right";
  format?: (value: number) => string;
}
const CloseIcon = styled("span")`
  position: absolute;
  right: 20px;
  top: 12px;
  cursor: pointer;
`;

const columns: readonly Column[] = [
  { id: "cmkl_id", label: "CMKL Id", minWidth: 90 },
  { id: "name", label: "Student first and last name", minWidth: 150 },
  {
    id: "nickname",
    label: "Student nickname",
    minWidth: 100,
  },
  {
    id: "email",
    label: "Email",
    minWidth: 100,
  },
  { id: "advisor", label: "Advisor", minWidth: 150 },
  { id: "status", label: "Status", minWidth: 150 },
  { id: "cie_dual_degree", label: "Dual Degree", minWidth: 150}
];

const SelectStudentModal = ({
  isOpen,
  setOpen,
  setStudent,
}: SelectStudentModalProps): JSX.Element => {
  const [loading, setLoading] = useState<boolean>(false);
  const [allStudents, setAllstudents] = useState<any>(null);
  const [students, setStudents] = useState<any>(null);

  const [onlyAdvisee, setOnlyAdvisee] = useState<boolean>(false);
  const semesterContext = useContext(SemesterContext);
  const [selectedSemester, setSelectedSemester] = useState<any>({
    label: "All",
    value: "",
    year: "",
  });
  const [searchString, setSearchString] = useState("");
  const [searchStudent, setSearchStudent] = useState<Array<any>>([]);
  const [isSearchApplied, setIsSearchApplied] = useState<boolean>(false);
  const [statusTypes, setStatusTypes] = useState<any>([]);
  const [selectedStatus, setSelectedStatus] = useState<any>({ label: 'Enrolled', value: 1 });

  const universityContext = useContext(UniversityContext);

  useEffect(() => {
    // fetchStudents();
    statusTypes.length === 0 && fetchStatustypes();
    isSearchApplied && onSearchStudent();
  }, [onlyAdvisee]);

  // useEffect(() => {
  //   onSemesterChange(selectedSemester);
  // }, [universityContext.selectedProgram]);
  const hasFetchedAllRef = useRef(false);

  useEffect(() => {
    if (isOpen && !hasFetchedAllRef.current) {

      fetchAllProgramStudents();
      hasFetchedAllRef.current = true;
    }
  }, [isOpen]);

  useEffect(() => {
    universityContext.setProgram({
      label: "ALL",
      value: "ALL",
      degree_abbrev: "",
      program_abbrev: "",
      id: "",
      description: "",
      first_semester: "",
      program_name: "All Programs",
      short_name: "",
      university_code: "",
      versions: [],
    });
  }, []);

  useEffect(() => {
    if (!searchString || searchString.trim() === "") {
      setSearchStudent([]);
      setIsSearchApplied(false);
      return;
    }

    const terms = searchString.trim().toLowerCase().split(/\s+/);
    const results = (allStudents || []).filter((stu: Student) => {
      const fullName = `${stu.first_name || ""} ${stu.last_name || ""}`.toLowerCase();
      return terms.every((term) =>
        (stu.nickname || "").toLowerCase().includes(term) ||
        (stu.first_name || "").toLowerCase().includes(term) ||
        (stu.last_name || "").toLowerCase().includes(term) ||
        (stu.email || "").toLowerCase().includes(term) ||
        fullName.includes(term)
      );
    });

    setSearchStudent(results);
    setIsSearchApplied(true);
  }, [searchString, allStudents]);

  const fetchStatustypes = async () => {
    // setLoading(true);
    axios
      .get("/student/status/type")
      .then((res) => setStatusTypes(res.data.student_status_type))
      .catch(() => { });
    // .finally(() => setLoading(false));
  };

  const fetchAllProgramStudents = async () => {
    setLoading(true);
    axios.get(`/student/all?university_code=CMKL`).then((res) => {
      if (res.data.students) {
        setAllstudents(res.data.students);
        const filteredStudent: Array<any> = [];
        if (onlyAdvisee) {
          res.data.students.filter((stu: any) => {
            // setSelectedSemester(semesterContext.semesters[0]);
            if (stu.advisor === user.name) filteredStudent.push(stu);
          });
          setStudents(filteredStudent);
        } else {
          setStudents(res.data.students.filter((s:any)=>s.programs?.[0]?.current_status?.new_status_title=== selectedStatus?.label));
          // onSemesterChange(selectedSemester);
        }
      } else {
        setStudents([]);
        setAllstudents([]);
      }
      setLoading(false);
    });
  };
  const fetchStudents = async (programOverride?: string) => {
    setLoading(true);

    const programValue =
      programOverride ?? universityContext.selectedProgram?.value;
    const programParam =
      !programValue || programValue === "ALL"
        ? ""
        : `&program_name=${programValue}`;

    const statusValue = selectedStatus?.value ?? "ALL";

    // setAllstudents([]);
    // setStudents([]);
    axios
      .get(`/student/all?university_code=CMKL${programParam}`)
      .then((res) => {
        if (res.data.students) {
          setAllstudents(res.data.students);

          let list = res.data.students.slice();

          if (selectedSemester && selectedSemester?.label !== "All") {
            list = list.filter(
              (stu: any) =>
                selectedSemester.label === stu?.programs?.[0]?.term_entered
            );
          }

          if (statusValue && statusValue !== "ALL") {
            list = list.filter(
              (stu: any) =>
                stu?.programs?.[0]?.current_status?.new_status === statusValue
            );
          }

          if (onlyAdvisee) {
            list = list.filter((stu: any) => stu.advisor === user.name);
          }

          setStudents(list);
        } else {
          setStudents([]);
          setAllstudents([]);
        }
        setLoading(false);
      })
      .catch((err) => {
        // setAllstudents([]);
        setStudents([]);
        setLoading(false);
        handleJWTError(err);
      });
  };
  const onSemesterChange = async (data: any, statusOverride?: any) => {
    // isSearchApplied && onSearchStudent();
    // setOnlyAdvisee(false);
    setLoading(true);
    setSelectedSemester(data);

    const statusValue = statusOverride ? statusOverride.value : selectedStatus?.value ?? "ALL";

    const programValue = universityContext.selectedProgram?.value;
    const programParam =
      programValue === "ALL" || !programValue
        ? ""
        : `&program_name=${programValue}`;
    setStudents([]);
    axios
      .get(`/student/all?university_code=CMKL${programParam}`)
      .then((res: any) => {
        if (res.data.students) {
          // setStudents([]);
          // if (data.label === "All") {
          //   if (onlyAdvisee) {
          //     const adviseeStudent: Array<any> = [];
          //     res.data.students.filter((stu: any) => {
          //       // setSelectedSemester(semesterContext.semesters[0]);
          //       if (stu.advisor === user.name) adviseeStudent.push(stu);
          //       setStudents(adviseeStudent);
          //     });
          //   } else setStudents(res.data.students);
          // } else {
          //   const filterStudentByYear = res.data.students.filter(
          //     (stu: any) => data.label === stu?.programs?.[0]?.term_entered
          //   );
          //   if (onlyAdvisee) {
          //     const adviseeStudent: Array<any> = [];
          //     filterStudentByYear.filter((stu: any) => {
          //       // setSelectedSemester(semesterContext.semesters[0]);
          //       if (stu.advisor === user.name) adviseeStudent.push(stu);
          //       setStudents(adviseeStudent);
          //     });
          //   } else {
          //     setStudents(filterStudentByYear);
          //   }
          // }

          // start from full fetched list
          let list = res.data.students.slice();

          // semester filter
          if (data.label !== "All") {
            list = list.filter(
              (stu: any) => data.label === stu?.programs?.[0]?.term_entered
            );
          }

          // status filter (statusValue is id from statusTypes, "ALL" means no filter)
          if (statusValue && statusValue !== "ALL") {
            list = list.filter(
              (stu: any) =>
                stu?.programs?.[0]?.current_status?.new_status === statusValue
            );
          }

          // only advisee filter
          if (onlyAdvisee) {
            list = list.filter((stu: any) => stu.advisor === user.name);
          }

          setStudents(list);
          setLoading(false);
        } else {
          setStudents([]);
          setLoading(false);
        }
      })
      .catch((err) => {
        setStudents([]);
        setLoading(false);
        handleJWTError(err);
      });
  };

  const statusOptions = [{ label: "ALL", value: "ALL" }, ...(statusTypes || []).map((s: any) => ({ label: s.title, value: s.id }))];


  // const onlyAdviseeChange = () => {
  //   setOnlyAdvisee(!onlyAdvisee);
  //   console.log('allStudents before filter', onlyAdvisee);
  //   if(onlyAdvisee){
  //     console.log('fetched')
  //   fetchAllProgramStudents();
  //   }
  // //   allStudents?.filter((stu: any) => {
  // //     if (onlyAdvisee) {
  // //           const filteredStudent = students.filter((stu: any) => {
  // //             // setSelectedSemester(semesterContext.semesters[0]);
  // //             if (stu.advisor === user.name)            
  // //               setStudents(filteredStudent);
  // //           });
  // //         } else {
  // //           // setStudents(res.data.students);
  // //           // onSemesterChange(selectedSemester);
  // //         }

  // // });
  // };

  const { user } = useContext(UserContext);

  const onlyAdviseeChange = () => {
    setOnlyAdvisee((prev) => {
      const next = !prev;

      const programValue = universityContext.selectedProgram?.value;
      const isAllProgram = !programValue || programValue === "ALL";

      const getProgramStudents = (): any[] => {
        if (isAllProgram) {
          return Array.isArray(allStudents) ? allStudents.slice() : [];
        }

        if (Array.isArray(allStudents) && allStudents.length > 0) {
          return allStudents.filter((stu: any) => {
            const p = stu.programs?.[0] || {};
            return (
              p.program_name === programValue ||
              p.program_abbrev === programValue ||
              p.id === programValue
            );
          });
        }

        if (!students || students.length === 0) {
          fetchStudents();
          return [];
        }
        return Array.isArray(students) ? students.slice() : [];
      };

      let baseList = getProgramStudents();

      if (selectedSemester && selectedSemester?.label !== "All") {
        baseList = baseList.filter(
          (stu: any) => stu?.programs?.[0]?.term_entered === selectedSemester?.label
        );
      }

      const statusValue = selectedStatus?.value ?? "ALL";
      if (statusValue && statusValue !== "ALL") {
        baseList = baseList.filter(
          (stu: any) =>
            stu?.programs?.[0]?.current_status?.new_status === statusValue
        );
      }

      if (next) {
        baseList = baseList.filter((stu: any) => stu.advisor === user.name);
      }

      setStudents(baseList);
      return next;
    });
  };

  const onSearchStudent = () => {
    let resultsObj =
      searchString.trimStart() !== ""
        ? allStudents?.filter((stu: Student) => {
          const fullName = `${stu.first_name} ${stu.last_name}`.toLowerCase();
          const searchTerms = searchString.trim().toLowerCase().split(" ");

          return searchTerms.every(
            (term) =>
              stu.nickname?.toLowerCase().includes(term) ||
              stu.first_name?.toLowerCase().includes(term) ||
              stu.last_name?.toLowerCase().includes(term) ||
              stu.email?.toLowerCase().includes(term) ||
              fullName.includes(term)
          );
        })
        : [];

    setSearchStudent(resultsObj);
    setIsSearchApplied(true);
  };
  const displayStudents = isSearchApplied
    ? students?.filter((student: any) =>
      searchStudent?.some((s) => s.id === student.id)
    )
    : students;

  const clearFilter = () => {
    setIsSearchApplied(false);
    setStudents(allStudents);
    setOnlyAdvisee(false);
    setSearchString("");
    setSelectedSemester(semesterContext.semesters[0]);
  };
  return (
    <>
      <Modal
        isOpen={isOpen || false}
        setOpen={setOpen}
        onClose={() => {
          universityContext.setProgram({
            label: "ALL",
            value: "ALL",
            degree_abbrev: "",
            program_abbrev: "",
            id: "",
            description: "",
            first_semester: "",
            program_name: "All Programs",
            short_name: "",
            university_code: "",
            versions: [],
          });
        }}
        customStyle={{
          overlay: {
            zIndex: "9999",
          },
          content: {
            maxWidth: "90vw",
            // maxHeight: "90vh",
            padding: "0px",
            background: "#0c0d22",
            margin: "calc(40px) auto 0px",
            border: "1px solid rgb(38 42 125)",
            boxShadow: "0px 4px 16px rgba(0, 0, 0, 0.07)",
            borderRadius: "8px",
          },
        }}
      >
        <CustomBox justify="between" width={"100%"}>
          <div style={{ marginBottom: 5 }}>
            <InputContainer
              // as="form"
              // onSubmit={(e: any) => {
              //   e.preventDefault();
              //   onSearchStudent();
              // }}
              style={{ width: "420px" }}
            >
              <Input
                value={searchString}
                id="search-input"
                name="searchInput"
                // eslint-disable-next-line max-len
                // onInput={(e: React.ChangeEvent<HTMLInputElement>) =>
                //   setSearchString(e.target.value)
                // }
                onInput={(e: React.ChangeEvent<HTMLInputElement>) => setSearchString(e.target.value)}

                placeholder="Name, nickname or email"
                style={{
                  width: "inherit",
                  color: "white",
                  // padding: "10px 20px",
                }}
              />
              {searchString !== "" && (
                <button
                  type="button"
                  onMouseDown={(e) => {
                    e.preventDefault();
                    setSearchString("");
                    setIsSearchApplied(false);
                  }}
                  style={{ background: "none", border: "none", padding: 0 }}
                >
                  <CloseIcon title="Clear Search">
                    <ClickableIcon
                      name="times"
                      onClick={() => { }}
                      style={{ color: "white" }}
                    />{" "}
                  </CloseIcon>
                </button>
              )}
              {/* <InputIconContainer
                title="Search"
                style={{
                  width: "40px",
                  height: "40px",
                  border: "1px solid transparent",
                  backgroundColor: "#8a4041",
                  // top: "3px",
                  // bottom: "6px",
                  color: "white",
                }}
                onClick={(e: any) => {
                  e.preventDefault();
                  onSearchStudent();
                  // setSearchValue("");
                }}
                  \]'[
                disabled={searchString === ""}
              >
                <Icon
                  sx={{
                    fontSize: "20px",
                  }}
                >
                  search-icon
                </Icon>
              </InputIconContainer> */}
            </InputContainer>
          </div>
          <FlexGrow
            style={{
              // flexGrow: "0",
              display: "flex",
              background: "#090a14",
              fontWeight: "bold",
              // justifyContent: "end",
              alignItems: "center",
              // paddingLeft: "12px",
              marginBottom: 5,
            }}
          >
            <>
              <div style={{}}>
                <div style={{ fontSize: 10, marginRight: 10 }}>
                  Initial Semester :{" "}
                </div>
                <StudentYearSelector
                  selectedSemeseter={selectedSemester}
                  setSelectedSemester={setSelectedSemester}
                  onSemesterChange={onSemesterChange}
                />
              </div>
              <div style={{ marginRight: 0 }}>
                <div style={{ fontSize: 10, marginLeft: 16 }}>Program : </div>
                <StyleElements>
                  <MinimalSelect
                    isDisabled={loading}
                    setClass={"custom-container"}
                    // setClass={"rs-container"}
                    required
                    placeholder="Program"
                    options={
                      // universityContext.programs || []
                      [
                        { label: "ALL", value: "ALL" },
                        ...(universityContext.programs || []),
                      ]
                    }
                    value={(() => {
                      const opts = [
                        { label: "ALL", value: "ALL" },
                        ...(universityContext.programs || []),
                      ];
                      const selected = universityContext.selectedProgram;
                      if (!selected?.value || selected.value === "ALL") {
                        return opts[0];
                      }
                      return (
                        opts.find(
                          (v: any) =>
                            v.short_name === selected.short_name ||
                            v.value === selected.value
                        ) || opts[0]
                      );
                    })()}
                    // value={
                    //   universityContext?.programs?.find(
                    //     (v: any) =>
                    //       v.program_abbrev ===
                    //       universityContext.selectedProgram?.program_abbrev
                    //   ) || universityContext?.programs?.[0]
                    // }
                    onChange={(newValue: any) => {
                      universityContext.setProgram(newValue);
                      fetchStudents(newValue.value);
                    }}
                  />
                </StyleElements>
              </div>
              <div style={{}}>
                <div style={{ fontSize: 10, marginLeft: 16 }}>Status : </div>
                <StyleElements>
                  <MinimalSelect
                    isDisabled={loading}
                    setClass={"custom-container"}
                    required
                    placeholder="Status"
                    options={statusOptions}
                    value={statusOptions.find((s: any) => s.value === selectedStatus?.value) || statusOptions[0]}
                    onChange={(newValue: any) => {
                      setSelectedStatus(newValue);
                      // reapply filters immediately using the newly selected status
                      onSemesterChange(selectedSemester, newValue);
                    }}
                  />
                </StyleElements>
              </div>
              <FlexBox
                style={{
                  // marginLeft: 10,
                  // background: "gray",
                  padding: "0px 20px 0px 20px",
                  borderRadius: 5,
                }}
              >
                <Checkbox
                  // defaultChecked={filters.includes(filter.value)}
                  checked={onlyAdvisee}
                  onChange={(e) => {
                    onlyAdviseeChange();
                    // e.target.checked
                    //   ? setOnlyAdvisee(true)
                    //   : setOnlyAdvisee(false);
                  }}
                  sx={{
                    color: "#FAFAFA",
                    "&.Mui-checked": {
                      color: "#FAFAFA",
                    },
                    marginRight: "0px !important",
                  }}
                />{" "}
                <div>Only Advisee</div>{" "}
              </FlexBox>

              {/* <MUIButton onClick={clearFilter} variant="text" color="warning">
                <span
                  style={{
                    color: "#ffff86",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <Icon
                    sx={{
                      // color: "#ffff86",
                      mr: 1,
                      textShadow: "0 1px 5px black",
                      // transform: "rotate(45deg)",
                      fontSize: "20px",
                    }}
                  >
                    refresh_icon
                  </Icon>{" "}
                  Clear all filters
                </span>
              </MUIButton> */}
            </>
          </FlexGrow>
          {/* <CancelButton onClick={() => setOpen(false)}> - Close</CancelButton> */}
          <MUIButton
            onClick={() => {
              setOpen(false);
              universityContext.setProgram({
                label: "ALL",
                value: "ALL",
                degree_abbrev: "",
                program_abbrev: "",
                id: "",
                description: "",
                first_semester: "",
                program_name: "All Programs",
                short_name: "",
                university_code: "",
                versions: [],
              });
            }}
            variant="contained"
          >
            Close
          </MUIButton>
        </CustomBox>

        {/* <FlexBox>
          <FlexGrow> */}
        <TableComponent height="80vh" aria-label="sticky table">
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <StyledTableCell
                  key={column.id}
                  align={column.align}
                  style={{
                    minWidth: column.minWidth,
                    fontWeight: "bold",
                    borderBottom: "1px solid #3C406C",
                  }}
                >
                  {column.label}
                </StyledTableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {loading ? (
              <LoadingSpinner />
            ) : (
              <>
                {displayStudents &&
                  displayStudents?.length === 0 &&
                  !loading ? (
                  <>
                    <StyledTableRow role="checkbox" tabIndex={-1} key={0}>
                      <StyledTableCell colSpan={5} key={1} align="center">
                        No matching student found!
                      </StyledTableCell>
                    </StyledTableRow>
                  </>
                ) : (
                  <>
                    {displayStudents?.map((row: any) => {
                      return (
                        <StyledTableRow
                          onClick={() => {
                            setStudent(row);

                            const selectedProgram = universityContext?.programs?.find(
                              (prog: any) => prog?.short_name === row?.programs?.[0]?.program_name
                            );
                            if (selectedProgram) {
                              universityContext.setProgram(selectedProgram);
                            }
                            // console.log('selected program:', row, programOptions);
                            setOpen(false);
                          }}
                          role="checkbox"
                          tabIndex={-1}
                          key={row.id}
                        >
                          {columns.map((column) => {
                            let value: string | JSX.Element = "";
                            if (column.id === "name") {
                              value = row.first_name + " " + row.last_name
                            } else if (column.id === "status") {
                              value = statusTypes?.find(
                                (sta: any) =>
                                  sta.id ===
                                  row.programs?.[0]?.current_status?.new_status
                              )?.title;
                            }
                            else if (column.id === "cie_dual_degree") {
                              value = (
                                <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                  {row.cie_dual_degree ? (
                                    <Icon
                                      sx={{
                                        color: "#4caf50",
                                        fontSize: "24px",
                                      }}
                                    >
                                      check
                                    </Icon>
                                  ) : (
                                    <Icon
                                      sx={{
                                        color: "#ffa600ff",
                                        fontSize: "24px",
                                      }}
                                    >
                                      close
                                    </Icon>
                                  )}
                                </div>
                              );
                            }
                             else {
                              value = row[column.id];
                            }
                            return (
                              <StyledTableCell
                                key={column.id}
                                align={column.align}
                              >
                                {column.format && typeof value === "number"
                                  ? column.format(value)
                                  : value}
                              </StyledTableCell>
                            );
                          })}
                        </StyledTableRow>
                      );
                    })}
                  </>
                )}
              </>
            )}
          </TableBody>
        </TableComponent>
        {/* </FlexGrow>
        </FlexBox> */}
      </Modal>
    </>
  );
};

export default SelectStudentModal;
